import GuestLayout from '../../components/layout/GuestLayout.jsx';
import BaseLink from '../../components/misc/BaseLink.jsx';

const ValidateAccount = () => {
    return (
        <GuestLayout title='Awaiting Admin Validation'>
            <div className='text-theme1-white mb-10'>
                Please wait for an admin to validate your account and assign you a role.
            </div>
            <div className='flex justify-center'>
                <BaseLink className='btn-link-guest-white' to='/logout'>
                    Logout
                </BaseLink>
            </div>
        </GuestLayout>
    );
};

export default ValidateAccount;
